<template>
  <van-row>
    <div v-title :data-title="this.$route.query.type == 1 ? '用户协议' : '隐私政策'"></div>
    <van-col span="22" offset="1" class="rich-text">
      <div v-html="richData"></div>
    </van-col>
    <RouterVIew :page="page" />
  </van-row>
</template>

<script>
  import { protocolType } from '@/api/index'
  export default {
    data() {
      return {
        richData: '<div>正在显示，请稍等...</div>',
        page: '/'
      };
    },
    created(){
      this.protocolType();
    },
    methods: {
      // 获取协议内容
      protocolType(){
        var typeNumber = this.$route.query.type == 1 ? 10 : 20;
        protocolType(typeNumber).then(res => {
          this.richData = res.data.protocolContent;
        })
      }
    },
  };
</script>

<style scoped lang="scss">
  .rich-text{
    background: white;
    margin-top: 3vh;
    margin-bottom: 3vh;
    border-radius: 8px;
    padding: 3vw;
    text-align: left;

    div{
      width: 100%;
      ::v-deep p:nth-child(1){
        text-align: center;
      }
    }
  }
</style>